import { listEventTimeSlots } from '../../api/listEventTimeSlots/listEventTimeSlots';
import { InitiatorsArgs } from '../initWidgetData';
import type { IHttpError } from '@wix/http-client';
import { AsyncComponentDataStatus } from '../../../components/DailyAgenda/state/types';
import { TriggeredByOptions } from '../../../utils/bi/consts';

export const initSlots = async (
  args: InitiatorsArgs,
  triggeredBy: TriggeredByOptions,
) => {
  const { flowAPI, setState, getState, biLogger } = args;
  const { selectedFilters, selectedDate, selectedTimezone } = getState();

  try {
    const { timeSlots, pagingMetadata } = await listEventTimeSlots({
      range: { from: selectedDate },
      flowAPI,
      filters: selectedFilters,
      timeZone: selectedTimezone,
    });

    if (!timeSlots) {
      setState({
        slots: {
          status: AsyncComponentDataStatus.ERROR,
          data: 'No slots found',
        },
        slotsMetaData: {
          status: AsyncComponentDataStatus.ERROR,
          data: 'No slots found',
        },
      });
      return;
    }

    setState({
      slots: {
        status: AsyncComponentDataStatus.IDLE,
        data: timeSlots,
      },
      slotsMetaData: {
        status: AsyncComponentDataStatus.IDLE,
        data: pagingMetadata,
      },
    });
    biLogger?.reportSessionsLoaded(triggeredBy, selectedDate, timeSlots);
  } catch (error) {
    setState({
      slots: {
        status: AsyncComponentDataStatus.ERROR,
        data: (error as IHttpError).response?.data,
      },
      slotsMetaData: {
        status: AsyncComponentDataStatus.ERROR,
        data: (error as IHttpError).response?.data,
      },
    });
    console.error('Error initializing slots:', error);
  }
};
